import { Component, OnInit, Input } from '@angular/core';
import { CommonsService } from 'src/app/services/commons.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  standalone: false,
  selector: 'app-success-process',
  templateUrl: './success-process.component.html',
  styleUrls: ['./success-process.component.scss']
})
export class SuccessProcessComponent implements OnInit {

  @Input() url: string;
  @Input() isRapidScore: boolean;
  @Input() headerFooter: boolean;
  show: boolean;
  showButton: boolean;
  constructor(private cs: CommonsService, private translate: TranslateService) { }

  ngOnInit() {
    this.cs.firstChargePage('Engagement', 'OK - proceso completado', 'funnel');
    this.cs.eventsAnalitics('visit screen', 'OK - proceso completado', 'engagement');
    const p = JSON.parse(sessionStorage.getItem('getParams'));
    if (p) {
      this.show = p[0] === '3';
    }

    // Establecer el idioma basado en sessionStorage
    const language = sessionStorage.getItem('language') || 'es_ES';
    this.translate.setDefaultLang(language);
    this.translate.use(language);
    document.documentElement.lang = language.substring(0, 2);;

  }

  close() {
    if (this.url.includes('http')) {
      sessionStorage.removeItem('auxParam');
      sessionStorage.removeItem('getParams');
      sessionStorage.removeItem('_k_engagement');
      sessionStorage.removeItem('Channel');
      window.location.href = this.url;
    }
  }

}
